import {
    onSettingsLoad,
    onSettingsSave,
    onSettingsSetLogo,
    onSettingsSetSplash,
} from "../../store/Settings/actions";
import { IoAddCircleOutline } from "react-icons/io5";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "../../components/Button/Button";
import PulseLoader from "react-spinners/PulseLoader";

const SettingsDesign = () => {
    const dispatch = useDispatch();
    const logoImgRef = useRef(null);
    const logoSplashRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(onSettingsLoad());
    }, []);

    const { logo, splash, loading } = useSelector(
        ({ settings: { logo, splash, loading } }) => ({ logo, splash, loading })
    );

    const onChangeLogo = (file) => dispatch(onSettingsSetLogo(file));
    const onChangeSplash = (file) => dispatch(onSettingsSetSplash(file));
    const onSave = () => {
        dispatch(onSettingsSave());
    };

    const onChangeLogoImg = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            onChangeLogo(reader.result);
        };

        reader.readAsDataURL(file);
    };
    const onChangeSplashImg = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = async () => {
            onChangeSplash(reader.result);
        };

        reader.readAsDataURL(file);
    };

    const onClickAddLogoImg = () => logoImgRef.current.click();
    const onClickAddSplashImg = () => logoSplashRef.current.click();

    return (
        <>
            <div className="py-3 my-3 center mx-auto flex bg-white rounded-lg shadow-lg px-4">
                <div className=" px-4 py-5  text-center w-1/2">
                    <div
                        className="mb-4 flex bg-blue-100 items-center file-input justify-center"
                        onClick={onClickAddLogoImg}
                        style={{
                            width: "200px",
                            height: "200px",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundImage: `url(${logo})`,
                        }}
                    >
                        <input
                            type="file"
                            className="hidden"
                            ref={logoImgRef}
                            onChange={onChangeLogoImg}
                        />

                        {!logo ? (
                            <div className="flex flex-col">
                                <div className="items-center">{t("Logo")}</div>
                                <div className="sub items-center">
                                    1024 x 1024 px
                                </div>
                                <div className="sub m-auto mt-5">
                                    <IoAddCircleOutline size={30} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>

                <div className=" px-4 py-5  text-center w-1/2">
                    <div
                        className="mb-4 flex bg-blue-100 items-center file-input justify-center"
                        onClick={onClickAddSplashImg}
                        style={{
                            width: "440px",
                            height: "230px",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                            backgroundImage: `url(${splash})`,
                        }}
                    >
                        <input
                            type="file"
                            className="hidden"
                            ref={logoSplashRef}
                            onChange={onChangeSplashImg}
                        />

                        {!splash ? (
                            <div className="flex flex-col">
                                <div className="items-center">
                                    {t("Splash")}
                                </div>
                                <div className="sub items-center">
                                    1024 x 2024 px
                                </div>
                                <div className="sub m-auto mt-5">
                                    <IoAddCircleOutline size={30} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            <Button onClick={onSave}>
                {loading ? (
                    <PulseLoader
                        color="rgba(79, 70, 229, 1)"
                        loading={loading}
                        size={5}
                    />
                ) : (
                    t("Save")
                )}
            </Button>
        </>
    );
};

export default SettingsDesign;
